import { useEffect } from "react";

/**
 * Sets per-page <title>, <meta name="description">, and canonical link.
 * Restores previous values on unmount so navigation doesn't leak.
 */
export default function SEOHead({ title, description, canonical }) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        // description
        let descEl = document.querySelector('meta[name="description"]');
        const prevDesc = descEl ? descEl.getAttribute("content") : null;
        if (description) {
            if (!descEl) {
                descEl = document.createElement("meta");
                descEl.setAttribute("name", "description");
                document.head.appendChild(descEl);
            }
            descEl.setAttribute("content", description);
        }

        // canonical
        let canonicalEl = document.querySelector('link[rel="canonical"]');
        const prevCanonical = canonicalEl ? canonicalEl.getAttribute("href") : null;
        if (canonical) {
            if (!canonicalEl) {
                canonicalEl = document.createElement("link");
                canonicalEl.setAttribute("rel", "canonical");
                document.head.appendChild(canonicalEl);
            }
            canonicalEl.setAttribute("href", canonical);
        }

        return () => {
            if (title) document.title = prevTitle;
            if (description && descEl && prevDesc !== null) descEl.setAttribute("content", prevDesc);
            if (canonical && canonicalEl && prevCanonical !== null) canonicalEl.setAttribute("href", prevCanonical);
        };
    }, [title, description, canonical]);

    return null;
}
